import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class PickRequestPayload extends RequestPayload {
    public pick: string | number;
}
